import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useGetOutlookTokenFromCodeMutation } from "../../../store/google-reservations/googleReservationsApi";

const Callback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [getOutlookToken] = useGetOutlookTokenFromCodeMutation()
  const getQueryParams = () => {
    const queryParams = new URLSearchParams(location.search);

    return {
      code: queryParams.get("code"),
    };
  };

  const { code } = getQueryParams();

  const getOutlook = async () => {
	try {
		await getOutlookToken(code || '').unwrap()
		navigate('/settings')
	} catch (e) {
		console.error(e);
	}
  }

  useEffect(()=>{
	if (code) {
		getOutlook()
	}
  }, [code])

  return <div>
	Loading...
	{/* {code && <CallbackEmails code={code} />} */}
	</div>;
};

export default Callback;
